import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export function section_headers() {

  var sections = gsap.utils.toArray('.header-section');

  sections.forEach((section) => {
    var parent  = $(section).parents('section'),
        icon    = $(section).find('.header-section-icon');

    if(parent.length == 0) parent = $(section).parents('article');
    if(parent.length == 0) parent = $(section).parent();

    gsap.to(section, {
        scrollTrigger: {
            trigger: parent,
            start: 'top 20%',
            scrub: 1,
            end: 'bottom 25%',
            markers: false,
            toggleClass: {targets: section, className: 'active'},
            pin: icon,
        },
    });

  })

}



// WEBPACK FOOTER //
// ./scripts/functions/anims.js